import * as ng from 'angular';
import { ArchiSmallServices } from '../../services/archismall.service';

class MaintenanceController implements ng.IController {

    static $inject: string[] = [
        '$state',
        'ArchiSmallServices',
        '$interval'
    ];

    constructor(
        private $state: any, // ng.IRootScopeService,
        private ArchiSmallServices: ArchiSmallServices,
        private $interval: any
    ) {
        let interval = $interval(() => {
            ArchiSmallServices.version()
                .then((response: any) => {
                    if (!response.isMaintenance) {
                      // console.log('manutenzione intervallo');

                        $interval.cancel(interval);
                        $state.go('home.home-index');
                    }
                });
        }, 60000);
    }
}


export const MaintenanceComponent: ng.IComponentOptions = {
    template: require('./maintenance.html'),
    controller: MaintenanceController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/maintenance/maintenance.ts